import React, { Component } from 'react';

const Ellipsis = ({children}) => {
    return ( 
        <td style={{ minWidth: 190, maxWidth: 200, overflow: "hidden", whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} title={children}>{children}</td>
     );
}
 
export default Ellipsis;